<template>
  <div class="w-100p">
    <div class="bg-light-purple p-x2">
      <donut-loading-dots
        v-if="!quantityAndCost || state.loading.includes('getStandardPricing') || state.loading.includes('getPremiumPricing')"
        class="f-jc p-t8 p-b6"
        :has-top-padding="false"
      />
      <div
        v-else
        class="f-ac f-sb"
      >
        <div class="t single-line">
          <span class="bold">{{ quantityAndCost.quantity }}</span>
          <span>{{ usersString }}</span>
        </div>
        <div class="f-ac">
          <div
            v-if="!state.customPricing"
            class="t dark-gray"
          >
            ${{ `${quantityAndCost[billingFreq]}/mo` }}
          </div>
          <i
            v-tooltip.top="state.messages.billing_proration_warnings[billingFreq]"
            class="material-icons md-16 dark-purple m-l"
          >help</i>
        </div>
      </div>
    </div>
    <div
      v-if="includePricingLink"
      class="m-tx2"
    >
      <a
        class="link underlines"
        href="https://help.donut.ai/en/articles/3423191-donut-pricing-free-standard-premium"
        target="_blank"
      >How we calculate pricing</a>
    </div>
  </div>
</template>

<script setup>
  import { computed, onBeforeMount } from 'vue';
  import { useStore } from 'vuex';

  const { dispatch, state } = useStore();

  const props = defineProps({
    planCode: {
      type: String,
      required: true,
      validator(value) { return ['paid_coffee', 'premium'].includes(value); },
    },
    includePricingLink: {
      type: Boolean,
      default: false,
    },
  });

  const quantityAndCost = computed(() => state.quantitiesAndCosts[props.planCode]);
  const usersString = computed(() => ` Donut user${quantityAndCost.value.quantity > 1 ? 's' : ''}`);
  const billingFreq = computed(() => (state.currentUser.plan_pricing_data.is_annual_frequency ? 'annual' : 'monthly'));

  onBeforeMount(() => {
    if (props.planCode === 'paid_coffee') {
      dispatch('getStandardQuantitiesAndCosts', { useCache: true });
    } else if (props.planCode === 'premium') {
      dispatch('getPremiumQuantitiesAndCosts', { useCache: true });
    }
  });
</script>
